import { AiringDateProps } from 'components/widgets/CardView/types';
import { useAppStore } from 'hooks';
import { DateFormatStyle, formatDate, formatLocalTime } from 'utils';

interface Props {
  date: {
    startDate: number;
    label?: string | undefined;
  }
}

// TODO: cover by units
function useAiringDate({ date }: Props): AiringDateProps | undefined {
  const {
    appStore: {
      localizationStore: { displayLanguage, latinLanguage },
    },
  } = useAppStore();

  if (!date.startDate) return;

  const locale = latinLanguage || displayLanguage;
  const airingTime = formatLocalTime({ date: date.startDate, locale });
  const airingLabel = date.label || '';
  const isFutureDate =  date.startDate > Date.now();
  const isPastDate = date.startDate < Date.now();

  const onlyLongWeekdayFormattedDate = formatDate(date.startDate, DateFormatStyle.OnlyLongWeekday, locale);
  const withoutWeekdayFormattedDate = formatDate(date.startDate, DateFormatStyle.WithoutWeekday, locale);
  const withLongWeekdayFormattedDate = formatDate(date.startDate, DateFormatStyle.WithLongWeekday, locale);

  return ({
    airingTime,
    airingLabel,
    isFutureDate,
    isPastDate,
    onlyLongWeekdayFormattedDate,
    withoutWeekdayFormattedDate,
    withLongWeekdayFormattedDate
  })
}

export { useAiringDate }
